import { render, staticRenderFns } from "./Points.template.vue?vue&type=template&id=5c5d9c50&scoped=true&"
var script = {}
import style0 from "./Points.template.vue?vue&type=style&index=0&id=5c5d9c50&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d9c50",
  null
  
)

export default component.exports